/* Lekker Lounge – reveal-on-scroll + copy code */
(function () {
  if (window.__llInit) return; window.__llInit = true;
  function reveal() {
    var els = document.querySelectorAll('.ll-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ll-copy]');
    if (!b) return;
    var code = b.getAttribute('data-ll-copy');
    var done = function () { var t = b.querySelector('[data-ll-copy-label]'); if (t) { var o = t.textContent; t.textContent = 'Copied!'; setTimeout(function () { t.textContent = o; }, 1800); } };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
